import request from '@/utils/request'

export function fetchInventoryList(params,componentType) {
  return request({
    url:`/${componentType}_inventory/list/`,
    method:'get',
    params:params
  })
}

export function fetchInventoryHistoryList(id, params,componentType) {
  return request({
    url:`/${componentType}_inventory/history/` + id,
    method:'get',
    params:params
  })
}


export function createInventory(data, componentType) {
  return request({
    url:`/${componentType}_inventory/create`,
    method:'post',
    data: data,
  })
}

export function updateInventory(id, data, componentType) {
  return request({
    url:`/${componentType}_inventory/update/` + id,
    method:'post',
    data:data
  })
}

export function updatePrice(id, params, componentType) {
  return request({
    url:`/${componentType}_inventory/updatePrice/` + id,
    method:'post',
    params:params
  })
}

export function deleteStock(id, componentType) {
  return request({
    url:`/${componentType}_inventory/delete/`+ id,
    method:'delete'
    })
}


export function fetchDefaultSkuList() {
  return request({
    url:'/common/defaultSkuList/',
    method:'get',
  })
}

